import { useEffect } from "react";
import { nanoid } from "nanoid";
import { sendConversionsEvent } from "api/conversions";

import { COOKIES } from "constants/enum";
import { getAppMode } from "utils/getAppMode";
import { getCookiesValueByName } from "utils/cookie";

import { FacebookEvents } from "./events";
import { sendFacebookEvent } from "./sendFacebookAnalitic";

export const useSendStartAnalitic = () => {
    const hasWindow = typeof window !== "undefined";

    const { isDevMode } = getAppMode();

    useEffect(() => {
        if (!hasWindow || isDevMode) {
            return;
        }

        // TODO: [AD-2301] marketing-cookie gate removed for Facebook PageView + CAPI below; restore if required.

        const email = decodeURIComponent(getCookiesValueByName(COOKIES.EMAIL));
        const phone = decodeURIComponent(getCookiesValueByName(COOKIES.PHONE));

        const eventID = nanoid();

        sendFacebookEvent(
            FacebookEvents.FORM_SUBMIT_FACEBOOK_PAGE_VIEW_EVENT,
            {},
            {
                eventID,
            }
        );

        const sendConversionApiEvent = async () => {
            const fbp = decodeURIComponent(getCookiesValueByName(COOKIES.FBP)),
                fbc = decodeURIComponent(getCookiesValueByName(COOKIES.FBC)),
                ua = window?.navigator?.userAgent;

            await sendConversionsEvent({
                eventName: FacebookEvents.FORM_SUBMIT_FACEBOOK_PAGE_VIEW_EVENT,
                eventSourceUrl: location.href,
                eventId: eventID,
                ...((fbp || fbc || ua) && {
                    userData: {
                        fbp,
                        fbc,
                        clientUserAgent: ua,
                        email,
                        phone,
                    },
                }),
            });
        };

        sendConversionApiEvent();
    }, [hasWindow, isDevMode]);
};
